import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const REPEAT = () => {
  return (
    <CardSection id="REPEAT" title="REPEAT">
      <Paragraph>
        텍스트 문자열의 가장 왼쪽(시작) 위치부터 시작하여 주어진 수의 문자를
        반환합니다.
      </Paragraph>
      <ListSection title="Syntax">
        <Paragraph accent>REPEAT(VALUE, REPEAT)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 반복할 문자열이나 열입니다.
          </Li>
          <Li>
            <b>REPEAT</b>는 VALUE를 반복하는 횟수입니다.
          </Li>
        </Ul>
      </ListSection>
      {/* <ListSection title="Example">
        <Paragraph accent>REPEAT(`set`, 3)</Paragraph>
        <Img src="computeLeft" />
      </ListSection> */}
    </CardSection>
  );
};
